import { Component, OnInit} from '@angular/core';
import { Globals } from '../../globals'
import { ISelectedStudent } from '../../Models/ISelectedStudent'

@Component({
  selector: 'SelectedStudent',
  templateUrl: './SelectedStudent.component.html',
})
export class SelectedStudentComponent {
  _myGlobals: Globals;

  constructor(private globals: Globals) {
    this._myGlobals = globals;
  }

}

